import { FC } from "react"
import clsx from "clsx"

interface IInputLabelProps {
    htmlFor?: string
    title?: string
    label?: string
    required?: boolean
    className?: string
    inputClass?: string
    children?: React.ReactNode
}

export const InputLabel: FC<IInputLabelProps> = ({
    htmlFor, title, label, required, className, children
}) => {
    if (!label)
        return <>{children}</>

    return (
        <div title={title} className={clsx(className, "d-flex flex-wrap flex-column gap-1")}>
            <label htmlFor={htmlFor}
                className={clsx(className, "form-label fw-semibold fs-7 my-0", { "required": required })}>
                {label}
            </label>
            {children}
        </div>
    )
}
